export const INTERVAL_PRESET_DAYS = [7, 14, 21, 28, 42, 56, 84];

export function formatDays(days: number | null | undefined): string {
  if (days == null) return '—';
  if (days > 0 && days % 7 === 0) {
    const weeks = days / 7;
    return `${weeks} week${weeks === 1 ? '' : 's'}`;
  }
  return `${days} day${days === 1 ? '' : 's'}`;
}

export function addDays(date: Date, days: number): Date {
  const next = new Date(date);
  next.setDate(next.getDate() + days);
  return next;
}
